import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SmartPanelManagerService, SmartSuggestion } from '../services/smart-panel-manager.service';
import { BuilderComponentType } from '../interfaces/builder-screen.models';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-smart-suggestions-panel',
  templateUrl: './smart-suggestions-panel.component.html',
  styleUrls: ['./smart-suggestions-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SmartSuggestionsPanelComponent implements OnInit, OnDestroy {
  @Input() componentType: BuilderComponentType | null = null;
  @Input() compact = false;

  suggestions: SmartSuggestion[] = [];
  showSuggestions = true;
  private destroy$ = new Subject<void>();

  constructor(
    private smartPanelManager: SmartPanelManagerService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadSuggestions();
    
    // Atualiza sugestões quando estados do painel mudam
    this.smartPanelManager.panelStates$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.loadSuggestions();
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadSuggestions() {
    if (this.componentType) {
      this.suggestions = this.smartPanelManager.getSmartSuggestions(this.componentType);
    }
  }

  applySuggestion(suggestion: SmartSuggestion) {
    if (!this.componentType) return;

    const isExpanded = suggestion.action === 'expand';
    this.smartPanelManager.updatePanelState(this.componentType, suggestion.panelId, isExpanded);
    
    // Remove sugestão aplicada da lista
    this.suggestions = this.suggestions.filter(s => s.panelId !== suggestion.panelId);
    this.cdr.markForCheck();
  }

  dismissSuggestion(suggestion: SmartSuggestion) {
    this.suggestions = this.suggestions.filter(s => s.panelId !== suggestion.panelId);
    this.cdr.markForCheck();
  }

  dismissAllSuggestions() {
    this.suggestions = [];
    this.cdr.markForCheck();
  }

  toggleSuggestions() {
    this.showSuggestions = !this.showSuggestions;
    this.cdr.markForCheck();
  }

  getConfidenceColor(confidence: number): string {
    if (confidence >= 0.8) return '#52c41a'; // Verde
    if (confidence >= 0.6) return '#faad14'; // Laranja
    return '#1890ff'; // Azul
  }

  getConfidenceText(confidence: number): string {
    if (confidence >= 0.8) return 'builderScreen.suggestions.confidence.high';
    if (confidence >= 0.6) return 'builderScreen.suggestions.confidence.medium';
    return 'builderScreen.suggestions.confidence.low';
  }

  getSuggestionIcon(suggestion: SmartSuggestion): string {
    return suggestion.action === 'expand' ? 'plus-circle' : 'minus-circle';
  }

  trackBySuggestion(index: number, suggestion: SmartSuggestion): string {
    return `${suggestion.panelId}-${suggestion.action}`;
  }
}
